export const PLAYLET_CODES = ['fetch', 'bubbles', 'hide_seek'] as const;
export type PlayletCode = typeof PLAYLET_CODES[number];
export function pickPlaylet(rng: () => number = Math.random): PlayletCode {
  return PLAYLET_CODES[Math.floor(rng() * PLAYLET_CODES.length)];
}
